import { getCurrentLang } from "@/utils/lang";

// 首页分类硬编码数据（替代 getChannelAll / getChannelById 接口）
// message 字段保持为 JSON 字符串，兼容现有 JSON.parse(channelRes.message) 逻辑
const channelData = {
  "zh-CN": [
    {
      id: 1,
      parentId: null,
      channelName: "查元器件",
      message: JSON.stringify([
        "RMM1-63H/3300 10A 价格",
        "TRH5L-80/3D16A30mA的断路器主要参数是什么？",
        "帮我找出正泰nxm极数3p壳架额定电流1000a的型号有哪些？",
      ]),
      orderBy: 1,
      sessionId: null,
      description: "元器件的价格、品牌、技术参数、替换方案",
      showImage: "https://dq123oss.dq123.com/dxx/channel/1-1.png?v=1",
    },
    {
      id: 2,
      parentId: null,
      channelName: "查行业知识",
      message: JSON.stringify([
        "国家规定的五个电压等级",
        "不同区域/国家的常用储能电池标准",
        "普通Excel的报价清单能否导入到利驰报价软件里？",
      ]),
      orderBy: 0,
      sessionId: null,
      description: "软件使用FAQ、行业知识、国家标准、品牌样本",
      showImage: "https://dq123oss.dq123.com/dxx/channel/1-2.png?v=1",
    },
    {
      id: 3,
      parentId: null,
      channelName: "查设备",
      message: null,
      orderBy: 2,
      sessionId: null,
      description: "推荐不同柜型、不同参数的产品BOM，为您加快工作效率",
      showImage: "https://dq123oss.dq123.com/dxx/channel/1-3.png?v=1",
    },
    {
      id: 4,
      parentId: null,
      channelName: "标书、图纸..",
      message: null,
      orderBy: 3,
      sessionId: null,
      description: "敬请期待..",
      showImage: null,
    },
    {
      id: 5,
      parentId: null,
      channelName: "查标书",
      message: null,
      orderBy: 4,
      sessionId: null,
      description: "描述...",
      showImage: null,
    },
    {
      id: 6,
      parentId: null,
      channelName: "查模型",
      message: null,
      orderBy: 5,
      sessionId: null,
      description: "描述...",
      showImage: null,
    },
  ],
  "en-US": [
    {
      id: 1,
      parentId: null,
      channelName: "Find Components",
      message: JSON.stringify([
        "Price of RMM1-63H/3300 10A",
        "What are the main parameters of the TRH5L-80/3D16A30mA circuit breaker?",
        "Help me find CHINT NXM models with 3 poles and a frame rated current of 1000A",
      ]),
      orderBy: 1,
      sessionId: null,
      description: "Component prices, brands, technical parameters and replacement solutions",
      showImage: "https://dq123oss.dq123.com/dxx/channel/1-1.png?v=1",
    },
    {
      id: 2,
      parentId: null,
      channelName: "Industry Knowledge",
      message: JSON.stringify([
        "The five voltage levels defined by the state",
        "Common energy storage battery standards in different regions/countries",
        "Can an ordinary Excel quotation list be imported into Leads quotation software?",
      ]),
      orderBy: 0,
      sessionId: null,
      description: "Software FAQ, industry knowledge, national standards and brand samples",
      showImage: "https://dq123oss.dq123.com/dxx/channel/1-2.png?v=1",
    },
    {
      id: 3,
      parentId: null,
      channelName: "Find Equipment",
      message: null,
      orderBy: 2,
      sessionId: null,
      description:
        "Recommends product BOMs with different cabinet types and parameters to speed up your work",
      showImage: "https://dq123oss.dq123.com/dxx/channel/1-3.png?v=1",
    },
    {
      id: 4,
      parentId: null,
      channelName: "Tenders, Drawings..",
      message: null,
      orderBy: 3,
      sessionId: null,
      description: "Coming soon..",
      showImage: null,
    },
    {
      id: 5,
      parentId: null,
      channelName: "Find Tenders",
      message: null,
      orderBy: 4,
      sessionId: null,
      description: "Description...",
      showImage: null,
    },
    {
      id: 6,
      parentId: null,
      channelName: "Find Models",
      message: null,
      orderBy: 5,
      sessionId: null,
      description: "Description...",
      showImage: null,
    },
  ],
};

export function getChannelAll(lang = getCurrentLang()) {
  return channelData[lang] || channelData["zh-CN"];
}

export function getChannelById(id, lang = getCurrentLang()) {
  const list = channelData[lang] || channelData["zh-CN"];
  return list.find((c) => c.id === Number(id)) || {};
}

export default { getChannelAll, getChannelById };
